import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import store from './store'
import 'leaflet/dist/leaflet.css'

import PrimeVue from 'primevue/config'
import Aura from '@primeuix/themes/aura'

//Gaperlu dikonfigurasi disini
// import VeeValidate from 'vee-validate'; // VeeValidate v3

loadFonts()

// Create app instance
const app = createApp(App)

// Use plugins
app.use(store)
app.use(router)
app.use(vuetify)

// app.use(VeeValidate)
app.use(PrimeVue, {
    theme: {
        preset: Aura
    }
})

// You do not need `productionTip` in Vue 3 — it's removed
// app.config.productionTip = false  ❌

// Mount the app
app.mount('#app')